import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitodamantaxi() {



    const cardData = {




keyword: "Mumbai to Daman Taxi",

headingDescription: "Shreesha Tours & Travels provides reliable, comfortable, and affordable Mumbai to Daman taxi services for families, couples, business travelers, tourists, and weekend vacationers. We offer one-way cabs, round-trip taxi services, same-day return trips, airport transfers, and customized outstation tour packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and enjoyable journey. Whether you are planning a beach holiday, honeymoon, family vacation, corporate outing, sightseeing trip, or weekend getaway, our Mumbai to Daman taxi service offers clean vehicles, professional drivers, and personalized travel solutions. Enjoy a scenic coastal drive while exploring Daman's beautiful beaches, Portuguese heritage, historic forts, churches, gardens, and popular tourist attractions with complete travel convenience.",

topPlaces: [
  {
    title: "Devka Beach",
    description: "Devka Beach is one of Daman's most visited beaches, known for its beautiful coastline, peaceful atmosphere, amusement park, gardens, and stunning sunset views. It is a favorite destination for families, couples, and tourists looking to relax by the Arabian Sea."
  },
  {
    title: "Jampore Beach",
    description: "Jampore Beach is famous for its calm waters, soft black sand, camel and horse rides, water sports, and relaxing coastal environment. It is an ideal destination for family picnics, beach walks, and weekend holidays."
  },
  {
    title: "Moti Daman Fort",
    description: "Moti Daman Fort is a magnificent Portuguese fort featuring massive stone walls, historic churches, colonial buildings, and panoramic sea views. It is one of Daman's most iconic landmarks and a must-visit destination for history lovers."
  },
  {
    title: "St. Jerome Fort",
    description: "St. Jerome Fort, also known as Nani Daman Fort, is a historic riverside fort famous for its impressive gateways, ancient architecture, and scenic views of the Daman Ganga River. It is a popular attraction for sightseeing and photography."
  },
  {
    title: "Bom Jesus Church",
    description: "Bom Jesus Church is one of the oldest and most beautiful churches in Daman, admired for its Portuguese architecture, intricate wooden interiors, and peaceful atmosphere. It is a major religious and historical landmark."
  },
  {
    title: "Dominican Monastery",
    description: "The ruins of the Dominican Monastery reflect Daman's rich Portuguese heritage and colonial history. Visitors explore the historic remains while enjoying the peaceful surroundings and architectural beauty."
  },
  {
    title: "Daman Ganga Riverfront",
    description: "The Daman Ganga Riverfront offers scenic views, pleasant walking areas, and a peaceful atmosphere where visitors can enjoy boating, photography, and relaxing evenings overlooking the river."
  },
  {
    title: "Mirasol Lake Garden",
    description: "Mirasol Lake Garden is a beautiful recreational destination featuring landscaped gardens, boating facilities, children's play areas, restaurants, and relaxing lakeside views. It is perfect for families and tourists of all ages."
  },
  {
    title: "Lighthouse, Daman",
    description: "The historic Daman Lighthouse offers breathtaking panoramic views of the Arabian Sea, beaches, and surrounding coastline. It is a favorite spot for photographers and visitors looking to enjoy spectacular sunset views."
  },
  {
    title: "Silvassa",
    description: "Located close to Daman, Silvassa is a popular tourist destination known for tribal culture, wildlife parks, gardens, museums, and adventure activities. Many travelers combine Daman and Silvassa in a single road trip for a complete coastal holiday experience."
  }
],



"services": [
  {
    "name": "Mumbai to Daman Taxi",
    "description": "Book Mumbai to Daman Taxi for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for family vacations, business trips, weekend getaways, and one way or round trip journeys. Enjoy doorstep pickup, transparent pricing, and 24x7 cab service for a hassle-free journey from Mumbai to Daman."
  },
  {
    "name": "Mumbai to Daman Cab",
    "description": "Hire Mumbai to Daman Cab for a smooth and enjoyable road trip with experienced drivers, clean vehicles, and affordable travel packages. Our chauffeur-driven cabs are perfect for family holidays, corporate travel, sightseeing tours, airport transfers, and comfortable long-distance transportation."
  },
  {
    "name": "Mumbai to Daman Taxi Service",
    "description": "Choose Mumbai to Daman Taxi Service for dependable transportation with premium AC vehicles, skilled chauffeurs, and flexible booking options. Travel comfortably with reliable cab services designed for business travelers, families, tourists, and weekend holiday trips."
  },
  {
    "name": "Mumbai to Daman Cab Service",
    "description": "Book Mumbai to Daman Cab Service for reliable interstate travel with professional drivers, comfortable seating, and well-maintained vehicles. Enjoy safe journeys with flexible one way and round trip packages at competitive prices."
  },
  {
    "name": "Mumbai to Daman Taxi Fare",
    "description": "Check Mumbai to Daman Taxi Fare with transparent pricing, affordable travel packages, and no hidden charges. Compare vehicle options including Sedan, Ertiga, Innova Crysta, and SUV cabs while enjoying comfortable and economical travel."
  },
  {
    "name": "Mumbai to Daman Cab Fare",
    "description": "Get the best Mumbai to Daman Cab Fare with budget-friendly pricing and premium chauffeur-driven vehicles. Enjoy quality service, comfortable rides, and reliable transportation for every journey."
  },
  {
    "name": "Mumbai to Daman Cab Booking",
    "description": "Complete Mumbai to Daman Cab Booking online with instant confirmation, flexible scheduling, and multiple vehicle options. Choose the ideal cab for your travel needs and enjoy doorstep pickup with professional chauffeur service."
  },
  {
    "name": "Mumbai to Daman Car Rental",
    "description": "Hire Mumbai to Daman Car Rental for comfortable chauffeur-driven travel with premium vehicles and customized travel plans. Ideal for family vacations, corporate trips, sightseeing tours, and private outstation transportation."
  },
  {
    "name": "Mumbai to Daman One Way Taxi",
    "description": "Book Mumbai to Daman One Way Taxi for economical single-trip travel without paying return charges. Enjoy fixed fares, professional drivers, clean AC vehicles, and reliable transportation for your one-way journey."
  },
  {
    "name": "Mumbai to Daman Round Trip Cab",
    "description": "Reserve Mumbai to Daman Round Trip Cab for convenient return travel with affordable round-trip packages and flexible schedules. Perfect for weekend holidays, family outings, business meetings, and sightseeing tours."
  },
  {
    "name": "Mumbai Airport to Daman Taxi",
    "description": "Choose Mumbai Airport to Daman Taxi for timely airport pickup and direct outstation travel. Our experienced chauffeurs provide comfortable airport transfers with premium AC vehicles and dependable service."
  },
  {
    "name": "Mumbai Airport to Daman Cab",
    "description": "Book Mumbai Airport to Daman Cab for reliable airport transfers with professional drivers, clean vehicles, and convenient pickup from all Mumbai airport terminals. Enjoy a stress-free journey directly to Daman."
  },
  {
    "name": "Navi Mumbai to Daman Cab",
    "description": "Hire Navi Mumbai to Daman Cab for comfortable long-distance travel with experienced chauffeurs and well-maintained vehicles. Perfect for business travel, family vacations, and holiday trips with flexible pickup options."
  },
  {
    "name": "Thane to Daman Taxi",
    "description": "Book Thane to Daman Taxi for safe and affordable intercity travel with professional drivers and comfortable AC vehicles. Enjoy reliable transportation with convenient booking and transparent pricing."
  },
  {
    "name": "Mumbai to Daman Outstation Cab",
    "description": "Choose Mumbai to Daman Outstation Cab for smooth long-distance travel with premium vehicles and experienced chauffeurs. Get Sedan, Ertiga, Innova Crysta, SUV, and luxury cab options for every travel requirement."
  },
  {
    "name": "Mumbai to Daman Private Taxi",
    "description": "Reserve Mumbai to Daman Private Taxi for personalized travel with dedicated chauffeur service, comfortable vehicles, and complete privacy throughout your journey. Ideal for families, couples, and business travelers."
  },
  {
    "name": "Mumbai to Daman Car Hire",
    "description": "Book Mumbai to Daman Car Hire for private chauffeur-driven transportation with spacious vehicles, flexible schedules, and professional service. Suitable for family vacations, corporate travel, and weekend trips."
  },
  {
    "name": "Mumbai to Daman Tourist Cab",
    "description": "Hire Mumbai to Daman Tourist Cab for sightseeing tours, beach holidays, and leisure travel with experienced chauffeurs and comfortable vehicles. Enjoy a relaxing trip with customized travel plans and convenient pickup services."
  },
  {
    "name": "Mumbai to Daman Family Trip Cab",
    "description": "Choose Mumbai to Daman Family Trip Cab for safe and comfortable family vacations with spacious seating, experienced drivers, and premium vehicles. Perfect for holidays, beach tours, and memorable family outings."
  },
  {
    "name": "Mumbai to Daman Innova Cab",
    "description": "Book Mumbai to Daman Innova Cab for spacious and comfortable travel with ample luggage capacity and professional chauffeur service. Ideal for families, business groups, and long-distance road trips."
  },
  {
    "name": "Mumbai to Daman Innova Crysta Cab",
    "description": "Reserve Mumbai to Daman Innova Crysta Cab for luxury outstation travel with premium comfort, spacious interiors, and experienced chauffeurs. Enjoy a smooth and relaxing journey for family and executive travel."
  },
  {
    "name": "Mumbai to Daman Ertiga Cab",
    "description": "Hire Mumbai to Daman Ertiga Cab for affordable 6 to 7 seater travel with comfortable seating and reliable chauffeur service. Suitable for family holidays, group travel, and weekend getaways."
  },
  {
    "name": "Mumbai to Daman Sedan Cab",
    "description": "Book Mumbai to Daman Sedan Cab for economical and comfortable travel with clean AC vehicles and experienced drivers. Perfect for couples, solo travelers, and corporate passengers seeking affordable transportation."
  },
  {
    "name": "Mumbai to Daman SUV Cab",
    "description": "Choose Mumbai to Daman SUV Cab for spacious travel with extra luggage capacity, premium comfort, and dependable chauffeur service. Ideal for families, groups, and travelers looking for a comfortable highway journey."
  },
  {
    "name": "Reliable Mumbai Daman Taxi Service",
    "description": "Book Reliable Mumbai Daman Taxi Service for trusted long-distance transportation with well-maintained vehicles, trained chauffeurs, affordable pricing, and excellent customer support. Enjoy safe, comfortable, and punctual cab services for business trips, family vacations, beach holidays, and one way or round trip travel."
  }
],
"tableData": [
  ["Mumbai to Daman Taxi", "Mumbai to Daman Cab"],
  ["Mumbai to Daman Taxi Service", "Mumbai to Daman Cab Service"],
  ["Mumbai to Daman Taxi Fare", "Mumbai to Daman Cab Fare"],
  ["Mumbai to Daman Cab Booking", "Mumbai to Daman Car Rental"],
  ["Mumbai to Daman One Way Taxi", "Mumbai to Daman Round Trip Cab"],
  ["Mumbai Airport to Daman Taxi", "Mumbai Airport to Daman Cab"],
  ["Navi Mumbai to Daman Cab", "Thane to Daman Taxi"],
  ["Mumbai to Daman Outstation Cab", "Mumbai to Daman Private Taxi"],
  ["Mumbai to Daman Car Hire", "Mumbai to Daman Tourist Cab"],
  ["Mumbai to Daman Family Trip Cab", "Mumbai to Daman Innova Cab"],
  ["Mumbai to Daman Innova Crysta Cab", "Mumbai to Daman Ertiga Cab"],
  ["Mumbai to Daman Sedan Cab", "Mumbai to Daman SUV Cab"],
  ["Reliable Mumbai Daman Taxi Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Private Mumbai to Daman Taxi for a Relaxing Coastal Journey",
    WhyChoosedescription: "Escape the city's busy lifestyle with Shreesha Tours & Travels' Mumbai to Daman taxi service. We offer comfortable outstation cabs for beach holidays, family vacations, business visits, and weekend getaways."
  },
  {
    WhyChooseheading: "Convenient Door-to-Door Outstation Travel",
    WhyChoosedescription: "Travel directly from your home, office, hotel, airport, or railway station in Mumbai to any destination in Daman without changing multiple modes of transport."
  },
  {
    WhyChooseheading: "Wide Selection of Comfortable Vehicles",
    WhyChoosedescription: "Book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars that suit solo travellers, couples, families, and groups."
  },
  {
    WhyChooseheading: "Ideal for Leisure, Business & Group Tours",
    WhyChoosedescription: "Our Mumbai to Daman taxi service is suitable for corporate travel, family holidays, beach vacations, destination events, sightseeing tours, and group excursions."
  },
  {
    WhyChooseheading: "Professional Drivers for Highway Travel",
    WhyChoosedescription: "Experienced chauffeurs ensure a safe and pleasant journey by following the best highway routes while maintaining comfort and punctuality throughout the trip."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Packages",
    WhyChoosedescription: "Whether you require a one-way drop, same-day return, weekend package, or multi-day tour, we provide travel options that fit your itinerary."
  },
  {
    WhyChooseheading: "Explore Popular Attractions in Daman",
    WhyChoosedescription: "Customize your trip by visiting Devka Beach, Jampore Beach, Moti Daman Fort, Nani Daman, Bom Jesus Church, Lighthouse, and other famous attractions."
  },
  {
    WhyChooseheading: "Quick Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy transparent fare details, prompt booking assistance, and dedicated customer support for a hassle-free Mumbai to Daman taxi experience."
  }
]

};

const faqData = [
  {
    question: "Can I hire a private taxi from Mumbai to Daman for a beach vacation?",
    answer: "Yes, private taxis are available for beach holidays, weekend getaways, sightseeing tours, and family vacations in Daman."
  },
  {
    question: "Is one-way Mumbai to Daman taxi booking available?",
    answer: "Yes, you can book both one-way and round-trip taxi services according to your travel plans."
  },
  {
    question: "Which vehicles are available for Mumbai to Daman travel?",
    answer: "We offer Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I include sightseeing places during my Daman trip?",
    answer: "Yes, your itinerary can include Devka Beach, Jampore Beach, Moti Daman Fort, Nani Daman, churches, gardens, and other attractions."
  },
  {
    question: "Is Mumbai to Daman taxi suitable for group travel?",
    answer: "Yes, spacious vehicles including Tempo Travellers are available for family groups, friends, and corporate outings."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location."
  },
  {
    question: "Can I book a same-day return taxi from Daman?",
    answer: "Yes, same-day return and customized round-trip packages are available depending on your travel schedule."
  },
  {
    question: "Are tolls and parking charges included in the taxi fare?",
    answer: "The fare structure depends on the selected package. Applicable tolls, parking fees, permits, and additional charges are explained before booking."
  },
  {
    question: "Is advance booking recommended for Mumbai to Daman taxis?",
    answer: "Yes, advance booking helps ensure better vehicle availability, especially during weekends and holiday seasons."
  },
  {
    question: "How can I reserve a Mumbai to Daman Taxi with Shreesha Tours & Travels?",
    answer: "Simply share your travel date, pickup location, destination, number of passengers, and preferred vehicle to receive a quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Chirag Patel",
    feedback: "We planned a weekend beach trip to Daman, and Shreesha Tours & Travels made the journey completely stress-free. The Innova was comfortable, and the driver was friendly and punctual.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Riddhi Shah",
    feedback: "Our Mumbai to Daman family vacation was enjoyable from the very beginning. The cab was neat, the ride was smooth, and the entire booking experience was simple and professional.",
    rating: 5
  }
];























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Daman Taxi",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-daman-taxi.webp",
  "description":
    "Book Mumbai to Daman Taxi with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai, Navi Mumbai, Thane, and Mumbai Airport to Daman with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for beach holidays, family trips, business travel, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-daman-taxi"
  }
};







    return (
        <div>


<Helmet>
  <title>Mumbai to Daman Taxi | Coastal Cab Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Daman Taxi with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai, Navi Mumbai, Thane, or Mumbai Airport to Daman with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Daman Taxi, Mumbai to Daman Cab, Mumbai to Daman Taxi Service, Mumbai to Daman Cab Service, Mumbai to Daman Taxi Fare, Mumbai to Daman Cab Fare, Mumbai to Daman Cab Booking, Mumbai to Daman Car Rental, Mumbai to Daman One Way Taxi, Mumbai to Daman Round Trip Cab, Mumbai Airport to Daman Taxi, Mumbai Airport to Daman Cab, Navi Mumbai to Daman Cab, Thane to Daman Taxi, Mumbai to Daman Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitodamantaxi;